import { DropdownChangeHandler } from '../../dropdownChangeHandlers'
import { handleApplyMountingSetting } from '../../Inputs'
import { getSnapnrackRafterSpacingDefault } from './SnapnrackPZSEInputForm'
import type { UltraRailMountingType } from './UltraRailTypes'

const applyRafterSpacingDefaultForMountingType: DropdownChangeHandler = (system) => {
  const integration = system.integration_json?.snapnrackUltraRail as Record<string, unknown> | undefined
  const mountingType = (integration?.mountingType ?? 'Rafter') as UltraRailMountingType
  handleApplyMountingSetting(
    'rafterSpacing',
    getSnapnrackRafterSpacingDefault(mountingType),
    system.uuid,
    'snapnrackUltraRail'
  )
}

export const snapnrackDropdownHandlers: Record<string, Record<string, DropdownChangeHandler>> = {
  mountingType: {
    Rafter: applyRafterSpacingDefaultForMountingType,
    Decking: applyRafterSpacingDefaultForMountingType,
    Metal: applyRafterSpacingDefaultForMountingType,
  },
}
